module.exports = __webpack_public_path__ + "img/bg-orange-og.acc6a0e3.png";